// index.js - loaded as a module
import { onClickWhatsapp } from './clickEvents.js'
import { createFeaturesDivFromJSON } from './domStructure/serviceFeatures.js'
import { createClientReviews } from './domStructure/clientReviews.js'
import { showModalHandler, hideModalHandler } from './domStructure/modalHandler.js'
import { createCopyrightAndCreatorSection } from './domStructure/footer.js'

const parentReqModal = "upvcModal"
const upvcModalDivId = "upvcModalStart"
const jsonFile = `${fantastic_windows_vars.api_url}/assets/JSON/upvcJson.json`


window.onload = function() {
    
    const featuresJson = `${fantastic_windows_vars.api_url}/assets/JSON/features.json`
    const sectionFeatures = document.querySelector('#featureSection')
    createFeaturesDivFromJSON(sectionFeatures, featuresJson)

    // const clientReviewSection = document.querySelector('#clientReviewSection')
    // createClientReviews(clientReviewSection, `${fantastic_windows_vars.api_url}/assets/JSON/customerReview.json`)

    const copyrightAndCreatorsJson = ""
    const copyrightAndCreatorSection = document.querySelector('#copyright-and-creators-id')
    createCopyrightAndCreatorSection(copyrightAndCreatorSection, copyrightAndCreatorsJson)
}

document.querySelector('#whatsapp-icon').addEventListener('click', (e) => {
    onClickWhatsapp()
})

$(`#${parentReqModal}`).on('show.bs.modal', showModalHandler(parentReqModal, upvcModalDivId, jsonFile, undefined))
$(`#${parentReqModal}`).on('hide.bs.modal', hideModalHandler(parentReqModal, upvcModalDivId))

const $dropdown = $(".dropdown")
const $dropdownToggle = $(".dropdown-toggle")
const $dropdownMenu = $(".dropdown-menu")
const showClass = "show"

// $(window).on("load resize", function() {
//     resizeWindowHandler(this, $(this), $dropdown, $dropdownToggle, $dropdownMenu, showClass)
// })

$(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 768px)").matches) {
        $dropdown.hover(
            function() {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "true");
                $this.find($dropdownMenu).addClass(showClass);
            },
            function() {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "false");
                $this.find($dropdownMenu).removeClass(showClass);
            }
        )
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
})
